import React, { useEffect, useState, useCallback } from 'react'
import Payment from './Payment';
import Select from 'react-select';
import { useFetch } from '../../api/FetchApiData';
import { isMobile } from 'react-device-detect';
import {QRScanner} from '../../utils/QR/QrCodeScan';
import { useInfiniteScroll } from '../../utils/InfiniteScroll';
import PaymentsMap from '../../map/payments/PaymentsMap';
import search_icon from '../../icons/searchbar_gray.webp';
import { useTranslation } from 'react-i18next';

if (isMobile)
    import('./payments_mob.css').then(() => {});
else
    import('./payments.css').then(() => {});

function Payments({User}) {
    
    const [payments,setPayments] = useState([]);
    const [filters,setFilters] = useState({display:'none',filters:{},btn:'+'});
    const [scanner,setScanner] = useState({display:false,data:null});
    const [notification,setNotification] = useState({text:"",color:'black',display:'none'});
    const [page,setPage] = useState({CurrentPage:1,MaxPage:1});
    const fetchData = useFetch();
    const [viewIsMap, setViewIsMap] = useState(false);
    const [hasMore,setHasMore] = useState(true);
    const {t} = useTranslation();
    let customStyles = {
        control: (provided) => ({
          ...provided,
        }),
        option: (provided) => ({
          ...provided,
        }),
        singleValue: (provided) => ({
          ...provided,
        }),
    };

    const displayFilters = ()=>
    {
        if(filters.display==='none')
            setFilters({...filters,display:'block',btn:'-'})
        else
            setFilters({...filters,display:'none',btn:'+'})
    }

    const onScan = (data)=>{
        fetchData.PutData({qr_code:data},'user/payment/').then((result)=>{
            if(result.result)
            {
                setNotification({text:"Vous pouvez recupérer l'argent", color:'green', display:'block'});
                setTimeout(()=>{setNotification({text:"", color:'black', display:'none'})},10000);
                for(let i=0; i<payments.length; i++)
                {
                    if(payments[i].id === result.payment.id)
                    {payments[i] = result.payment;setPayments([...payments]);}
                }
            }
            else
            {
                setNotification({text:result.error, color:'orangered', display:'block'});
                setTimeout(()=>{setNotification({text:"", color:'black', display:'none'})},10000);
            }
        });
    }

    const FetchPayments = useCallback(async ()=>{
        if(page.CurrentPage<=page.MaxPage)
        {
            fetchData.PostData({mypayments:false},`user/payment/${page.CurrentPage}/`).then((result)=>{
                if(result.result)
                {
                    if(page.CurrentPage>result.maxpage)
                        setHasMore(false);
                    else
                    {setPayments([...payments,...result.payments]);setPage({...page,CurrentPage:page.CurrentPage+1,MaxPage:result.maxpage});}
                }
            })
        }
    },[page.CurrentPage]);

    const LoadMoreRef = useInfiniteScroll(FetchPayments,hasMore);
    
    if (!viewIsMap)
    {
        return(
            <div className="payments" style={{margin:'auto'}}>
                <div style={{width:'100%'}}>
                    {  User.is_staff && 
                        <div style={{marginBottom:'10px'}}>
                            <div className="sales-filters-title">
                                <input onClick={e=>{displayFilters()}} style={{border:'none'}} className="sales-filter-title-btn" type="button" value={filters.btn} />
                                <label className="sales-filter-title-label">{t('filters.filtres')}</label>
                            </div>
                            <fieldset style={{display:filters.display}} className="sales-filters">
                                <div className="sales-champs">
                                <label className="sales-champs-label">Tri : </label>
                                    <select className="sales-filter-control">
                                        <option>Les plus recents</option>
                                        <option>Par mois</option>
                                        <option>Par jour</option>
                                        <option>Par semaine</option>
                                        <option>Toutes les commandes</option>
                                    </select>
                                </div>
                                <div className="sales-champs">
                                    <label className="sales-champs-label">{t('sales.partenaires')} </label>
                                    <Select isSearchable={false} placeholder={t('sales.partenaires')} className="sales-filter-control" styles={customStyles} />
                                </div>
                                <div className="sales-champs">
                                    <label className="sales-champs-label">{t('sales.status')} </label>
                                    <Select isSearchable={false} placeholder={t('sales.status')} className="sales-filter-control" styles={customStyles} />
                                </div>
                            </fieldset>
                        </div>
                    }
                    {(User.is_staff || User.is_partner || User.is_deliver) &&
                    <>
                        <div className="sales-search" style={{border:'1px solid lightgray',borderRadius:'5px'}}>
                            <input className="sales-search-control" type="search" placeholder={t("produit.reference")} />
                            <img id="sales-filtres-qrscan" src={search_icon} style={{height:'30px',verticalAlign:'middle',float:'right'}} />
                        </div>
                       
                        <div>
                            {(User.is_staff) && <input onClick={e=>{setViewIsMap(!viewIsMap)}} type="button" value={t('sales.map')} className='payments-btn' />}
                             {/*<input type='button' onClick={e=>{setScanner({...scanner,display:!scanner.display})}} className='payments-btn' value={'Recupérer un paiement'} />*/}
                        </div>
                    </> 
                    }
                </div>
                <div style={{display:notification.display}}>
                    <p style={{fontWeight:'bold',color:notification.color}}>{notification.text}</p>
                </div>
                {
                    payments.map((payment,index)=>{ 
                        return(<Payment key={index} _payment={payment} User={User} setNotification={setNotification} />);
                    })
                }
                <div ref={LoadMoreRef} style={{height:'20px'}}/>
                {scanner.display && <QRScanner close={()=>{setScanner({...scanner,display:false})}} onScan={(data)=>{onScan(data);setScanner({display:false,data:data});}} />}                
            </div>
        );
    }
    else
    {
        return(
        <div className="payments" style={{margin:'auto'}}>
            <PaymentsMap close={setViewIsMap} />
        </div>);
    }
}
export default Payments
